import React from 'react';
import ShortListColumn from './ShortListColumn.mjs';
import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = 0;

export default function ShortList() 
{
    const { app_user} = useCTAL();

    if (!app_user) return;

    if (DEBUG) { console.log(`ShortList - UserID: ${app_user.UserID}`); return; }

    return ( <> <ShortListColumn /> </> );
}
